import {
  call, put, takeLatest, all, select,
} from 'redux-saga/effects';
import { authRequest } from '../../helpers/request.helper';

import {
  IMPORTAR_CATALOGO_PROPIO_REQUEST,
  IMPORTAR_CATALOGO_PROPIO_SUCCESS,
  IMPORTAR_CATALOGO_PROPIO_FAILURE,
} from '../actions/constants/catalogosPropios.constants';

const userData = state => state.auth.user;

function* importar({ payload: { proveedor, fileList: { catalogo, imagenes } } }) {
  try {
    const formData = new FormData();
    const user = yield select(userData);
    formData.append('user', JSON.stringify(user));
    formData.append('proveedor', proveedor);
    if (catalogo) {
      formData.append('ficheroCatalogo', catalogo);
    }
    if (imagenes) {
      formData.append('ficheroImagenes', imagenes);
    }

    const params = {
      url: 'api/catalogos/deipe/importar',
      method: 'POST',
      body: formData,
    };

    const response = yield call(authRequest, params);
    yield put({
      type: IMPORTAR_CATALOGO_PROPIO_SUCCESS,
      payload: response,
    });
  } catch (error) {
    yield put({
      type: IMPORTAR_CATALOGO_PROPIO_FAILURE,
      payload: error,
    });
  }
}

function* importarCatalogosPropios() {
  yield all([
    takeLatest(IMPORTAR_CATALOGO_PROPIO_REQUEST, importar),
  ]);
}

export default importarCatalogosPropios;
